import React, { useCallback, useEffect, useState } from 'react';
import { api } from '../services/api';
import { ObstacleGroup } from '../types';

/**
 * Šta ne može u turu i zašto.
 *
 * Svaki od ovih podataka je i do sada postojao, ali razbacan po ekranima — pa je
 * operater gledao praznu listu za neko mesto i nije imao gde da proveri zašto je
 * prazna. Najtiši uzrok je tura koja stoji otvorena: roba je rezervisana, a
 * nigde ne piše da je drži tura od pre tri dana.
 *
 * Uz svaku grupu stoji <b>šta se radi</b>. Spisak bez toga je samo prigovor.
 */
export default function Obstacles() {
  const [groups, setGroups] = useState<ObstacleGroup[] | null>(null);
  const [error, setError] = useState<string | null>(null);
  const [open, setOpen] = useState<string | null>(null);

  const load = useCallback(async () => {
    try {
      const result = await api.obstacles();
      setGroups(result);
      setOpen((current) => current ?? result[0]?.kind ?? null);
      setError(null);
    } catch (e) {
      setError(e instanceof Error ? e.message : String(e));
    }
  }, []);

  useEffect(() => {
    void load();
  }, [load]);

  if (error) {
    return <div className="health health--bad">{error}</div>;
  }

  if (!groups) {
    return <p className="muted">Učitavam…</p>;
  }

  if (groups.length === 0) {
    return (
      <section className="panel">
        <h2>Ne može u turu</h2>
        <p className="empty">
          <strong>Ništa ne stoji.</strong><br />
          Sve što čeka prevoz može u turu: adrese su potvrđene, objekti imaju
          tačku, nalozi imaju odredište, i nijedna tura ne stoji otvorena.
        </p>
      </section>
    );
  }

  return (
    <div className="obstacles">
      {groups.map((group) => {
        const isOpen = open === group.kind;

        return (
          <section key={group.kind} className="panel panel--todo">
            <button
              type="button"
              className="disc__head"
              aria-expanded={isOpen}
              onClick={() => setOpen(isOpen ? null : group.kind)}
            >
              <span className="disc__caret" aria-hidden="true">›</span>
              <span className="disc__title">{group.title}</span>
              <span className="count">
                {group.count}
                {group.pieces > 0 && <span className="muted"> · {group.pieces} kom</span>}
              </span>
            </button>

            <p className="note">{group.whatToDo}</p>

            {isOpen && (
              <ul className="rows disc__body">
                {group.items.map((item, index) => (
                  <li key={`${group.kind}-${index}`}>
                    <span className="row__name">{item.label}</span>

                    <span className="row__side">
                      {item.waitingDays !== null && (
                        <span className={item.waitingDays > 2 ? 'flag flag--warn' : 'flag'}>
                          {item.waitingDays === 0 ? 'danas' : `${item.waitingDays} d`}
                        </span>
                      )}
                    </span>

                    {item.detail && <span className="row__meta">{item.detail}</span>}
                  </li>
                ))}
              </ul>
            )}
          </section>
        );
      })}
    </div>
  );
}
